import React from 'react';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

export default function ShirtField(props) {
    const {field} = props;
    return (<Select clearable={false} options={[
        { id: 'XS', name: 'XS' },
        { id: 'S', name: 'S' },
        { id: 'M', name: 'M' },
        { id: 'L', name: 'L' },
        { id: 'XL', name: 'XL' },
        { id: 'XXL', name: 'XXL' },
        { id: 'XXXL', name: 'XXXL' }
    ]} placeholder={LocalizedStrings.shirtSize}  {...field} onChange={(item)=>field.onChange(item.value)}/>)

}



// WEBPACK FOOTER //
// ./src/js/components/form/shirt-field.js